import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import AlertModal from "../components/AlertModal";
import { signInEmailLink } from "../utils/firebase/auth";

const defaultAlertConfig = {
    isOpen: false,
    isConfirm: true,
    message: '',
};

const VerifiedPage = () => {
  const navigate = useNavigate();
  const [alertConfig, setAlertConfig] = useState({ ...defaultAlertConfig });
  const hasAttemptedSignInRef = useRef(false);

  const hideAlert = () => {
    setAlertConfig({ ...defaultAlertConfig })
    navigate('/')
  };

  useEffect(() => {
    if (hasAttemptedSignInRef.current) return;
    hasAttemptedSignInRef.current = true;
    async function signUserIn() {
        try {
            await signInEmailLink();
            const params = new URLSearchParams(window.location.search);
            if (params.has('return')) {
                const returnUrl = new URL(params.get('return'), window.location.origin);
                returnUrl.searchParams.set('verified', 'true');
                window.location.href = returnUrl.toString();
            }
        } catch (error) {
            setAlertConfig({
                isOpen: true,
                isConfirm: false,
                message: `Email verification failed: ${error}\nTry opening your latest verification link again.`
            })
        }
    };

    signUserIn();
  }, [navigate])
  
  return (
    <div className="min-vh-100 d-flex flex-column justify-content-center align-items-center gap-4 text-center px-3" role="status" aria-live="polite">
        <AlertModal alertConfig={alertConfig} handleCloseOnClick={hideAlert} />

        <Spinner
            type="grow"
            className="text-primary-orange"
            aria-hidden="true"
            style={{
                height: '8rem',
                width: '8rem'
            }}
        >
            Verifying your email...
        </Spinner>
        <span className="fs-5 fw-medium text-secondary">Verifying your email...</span>
    </div>
  );
};

export default VerifiedPage;
